export class DoorOracleError extends Error {
  code?: string;

  constructor(message: string, code?: string) {
    super(message);
    this.name = 'DoorOracleError';
    this.code = code;
  }
}

export function throwOnError<T>(
  result: { data: T; error: { message?: string; code?: string } | null },
  fallback: string
): T {
  if (result.error) {
    const raw = result.error.message || fallback;
    const missingColumn =
      /created_by|updated_by|collection|mapping_id|finish_id|schema cache/i.test(raw) && /column/i.test(raw)
        ? `${raw} Apply the latest supabase/migrations/202608251*.sql files in the Supabase SQL editor.`
        : raw;
    throw new DoorOracleError(missingColumn, result.error.code);
  }
  return result.data;
}

export function isUniqueViolation(error: unknown): boolean {
  if (!(error instanceof DoorOracleError)) return false;
  const haystack = `${error.code ?? ''} ${error.message}`.toLowerCase();
  return error.code === '23505' || haystack.includes('duplicate key') || haystack.includes('unique constraint');
}
